import { render, staticRenderFns } from "./active.vue?vue&type=template&id=1bf33aab&scoped=true&"
import script from "./active.vue?vue&type=script&setup=true&lang=js&"
export * from "./active.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./active.vue?vue&type=style&index=0&id=1bf33aab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf33aab",
  null
  
)

export default component.exports